import type { MouseEvent } from "react";

import { Icons } from "../../shared/ui";
import { adminHref } from "./adminRoute";
import { useShellT } from "./useShellT";

/**
 * Header of a section screen on narrow viewports: a back link to the section
 * list and the section title as a large title.
 */
export function AdminDetailHeader({
  title,
  onBack,
}: {
  title: string;
  onBack: () => void;
}) {
  const t = useShellT();
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0)
      return;
    event.preventDefault();
    onBack();
  };
  return (
    <header className="flex flex-col gap-1">
      <a
        href={adminHref({})}
        aria-label={t("admin.shell.back")}
        onClick={onClick}
        className="-ml-2 inline-flex min-h-11 min-w-11 items-center gap-0.5 self-start rounded-lg px-2 text-body font-medium text-accent-fg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus"
      >
        <Icons.ChevronLeft size={20} />
        <span>{t("admin.shell.back")}</span>
      </a>
      <h1 className="text-large-title tracking-large-title text-fg">{title}</h1>
    </header>
  );
}
